import Delegate from 'ftdomdelegate'

export default class ProductItemColorSwatch {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);

    this.delegateElement.on('change', '.colorSwatch__radio', this._colorChanged.bind(this));
  }

  _colorChanged(event, target) {
      // We need to change the URL of the various links
      var productItem = target.closest('.productItem'),
          variantUrl = target.getAttribute('data-variant-url');

      productItem.querySelector('.productItem__imageWrapper').setAttribute('href', variantUrl);
      productItem.querySelector('.productItem__title > a').setAttribute('href', variantUrl);

      // If we have a custom image for the variant, we change it
      var originalImageElement = productItem.querySelector('.productItem__image:not(.productItem__image--alternate)');

      if (target.hasAttribute('data-image-url') && target.getAttribute('data-image-id') !== originalImageElement.getAttribute('data-image-id')) {
        var newImageElement = document.createElement('img');
        newImageElement.className = 'productItem__image image--fadeIn image--lazyLoad';
        newImageElement.setAttribute('data-image-id', target.getAttribute('data-image-id'));
        newImageElement.setAttribute('data-src', target.getAttribute('data-image-url'));
        newImageElement.setAttribute('data-widths', target.getAttribute('data-image-widths'));
        newImageElement.setAttribute('data-sizes', 'auto');

        // Replace the original node
        if (window.theme.productImageSize === 'natural') {
          originalImageElement.parentNode.style.paddingBottom = 100.0 / target.getAttribute('data-image-aspect-ratio') + '%';
        }

        originalImageElement.parentNode.style.setProperty('--aspect-ratio', target.getAttribute('data-image-aspect-ratio'));
        originalImageElement.parentNode.replaceChild(newImageElement, originalImageElement);
      }
    }
  }